<template>
  <v-card ripple link flat :to="route">
    <v-img
      v-if="poster"
      :aspect-ratio="3 / 2"
      class="white--text align-end rounded grey lighten-2"
      :src="poster"
      :lazy-src="poster"
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>
    <v-img
      v-else
      :aspect-ratio="3 / 2"
      class="white--text align-end"
      src="../assets/empty/no-poster.svg"
    />
    <v-card-subtitle class="text-truncate pb-0">
      <div v-if="is_post_event" class="red--text">Event Berakhir</div>
      <div v-else>{{ date }}</div>
    </v-card-subtitle>
    <v-card-title class="pt-0 subtitle-1 font-weight-bold" style="width: 100%;"
      >{{ title }}
    </v-card-title>
    <v-card-subtitle class="text-truncate"
      >Oleh {{ publisher }}</v-card-subtitle
    >
  </v-card>
</template>

<script>
export default {
  name: 'ArticleCard',
  props: {
    title: String,
    date: String,
    is_post_event: Boolean,
    poster: String,
    publisher: String,
    route: Object,
  },
};
</script>

<style scoped>
.rounded {
  border-radius: 5px;
  border: 1px solid #dbdbdb;
}
.subtitle-1 {
}
</style>
